import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballTeamService } from "../../../../../../../commons";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";
import { FootballTeamCoach } from "../../../../../../../commons/models/football/football-team-coach";
import { EnsueCollection } from "../../../../../../../ensue-react-system/utilities/ensue-collection";

export interface IManageSubTeamCoachsState {
  manageSubTeamCoachsList: EnsueCollection<FootballTeamCoach>;
  manageSubTeamCoachsListStatus: StatusEnum;
}

export interface IManageSubTeamCoachesOption {
  teamId: number;
  subTeamId: number;
  urlParams?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

const initialState: IManageSubTeamCoachsState = {
  manageSubTeamCoachsList: new EnsueCollection<FootballTeamCoach>(),
  manageSubTeamCoachsListStatus: StatusEnum.Idle,
};

export const fetchManageSubTeamCoachList = createAsyncThunk(
  "manage/subTeamCoachList",
  async (options: IManageSubTeamCoachesOption, thunkAPI) => {
    try {
      const manageSubTeamCoachsList = await manageFootballTeamService.getSubTeamCoaches(
        options.teamId,
        options.subTeamId,
        options.urlParams
      );
      return manageSubTeamCoachsList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageSubTeamCoachListSlice = createSlice({
  name: "subTeamCoachList",
  initialState: initialState,
  reducers: {
    cleanUpManageSubTeamCoaches(state) {
      state.manageSubTeamCoachsList = new EnsueCollection<FootballTeamCoach>();
      state.manageSubTeamCoachsListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSubTeamCoachList.pending, (state) => {
        state.manageSubTeamCoachsListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSubTeamCoachList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballTeamCoach>>) => {
          state.manageSubTeamCoachsListStatus = StatusEnum.Succeeded;
          state.manageSubTeamCoachsList = action.payload;
        }
      )
      .addCase(fetchManageSubTeamCoachList.rejected, (state) => {
        state.manageSubTeamCoachsListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManageSubTeamCoaches } = manageSubTeamCoachListSlice.actions;
export default manageSubTeamCoachListSlice.reducer;
